
import i18next from 'i18next';
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';
import moment from 'moment';
import clsx from "clsx";
import { getEvDataScopeChangeFieldValue, isEvDataExpired } from 'services/common/EcovadisUtils';

const EcovadisScoresDates = ({ evData }) => {
  const { classes } = useStyles();
  
  return (
    <div className={classes.notableDates}>
      <div className={classes.dateDetail}>
        <div className={classes.dateLabel}>{i18next.t('publishedDate')}</div>
        <div className={classes.dateValue}>
          {getEvDataScopeChangeFieldValue(evData, 'published_date')
            ? moment(getEvDataScopeChangeFieldValue(evData, 'published_date')).format(
                i18next.t('date.dateFormat')
              )
            : ''}
        </div>
      </div>
      <div className={classes.dateDetail}>
        <div className={classes.dateLabel}>{i18next.t('updated')}</div>
        <div className={classes.dateValue}>
          {evData?.status_last_update
            ? moment(evData.status_last_update).format(
                i18next.t('date.dateFormat')
              )
            : ''}
        </div>
      </div>
      <div className={classes.dateDetail}>
        <div className={classes.dateLabel}>{i18next.t('expirationDate')}</div>
        <div className={clsx(classes.dateValue, isEvDataExpired(evData) ? "date-expired" : "")}>
          {getEvDataScopeChangeFieldValue(evData, 'published_date')
            ? moment(getEvDataScopeChangeFieldValue(evData, 'published_date'))
                .add(1, 'y')
                .format(i18next.t('date.dateFormat'))
            : ''}
        </div>
      </div>
    </div>
  );
};

export default EcovadisScoresDates;